/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import { parseNumber } from '@jalik/form-parser'
import FormNumberField, {
  FormNumberFieldProps
} from '../../../../client/js/components/form/fields/FormNumberField'

function LandAreaField (props: FormNumberFieldProps) {
  const { name = 'landArea', ...others } = props
  const intl = useIntl()
  return (
    <FormNumberField
      label={intl.formatMessage({
        id: 'land_area',
        defaultMessage: 'Superficie du terrain'
      })}
      name={name}
      parser={parseNumber}
      suffix={' m²'}
      {...others}
    />
  )
}

export default LandAreaField
